export const getAcronym = (str) => {
  if (!str) return "";

  const matches = str.match(/\b(\w)/g);
  const acronym = matches.join("");
  return acronym.slice(0, 2).toUpperCase();
};
